<template>
	<div class="inline-flex items-center gap-2">
		<!-- Undo button -->
		<button
			type="button"
			class="shrink-0 cursor-pointer disabled:opacity-40 disabled:cursor-default transition"
			:disabled="!canUndo"
			@click="onUndo"
			:title="$t('Undo')"
			tabindex="-1"
		>
			<ArrowUturnLeftIcon class="w-5 h-5" />
		</button>

		<!-- Redo button -->
		<button
			type="button"
			class="shrink-0 cursor-pointer disabled:opacity-40 disabled:cursor-default transition"
			:disabled="!canRedo"
			@click="onRedo"
			:title="$t('Redo')"
			tabindex="-1"
		>
			<ArrowUturnRightIcon class="w-5 h-5" />
		</button>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Editor } from "@tiptap/vue-3";
import { ArrowUturnLeftIcon, ArrowUturnRightIcon } from "@heroicons/vue/24/outline";

export default defineComponent({
	name: "UndoRedoComponent",
	components: { ArrowUturnLeftIcon, ArrowUturnRightIcon },
	props: {
		editor: { type: Object as PropType<Editor | null | undefined>, required: true },
	},
	computed: {
		canUndo(): boolean {
			return this.editor ? !!(this.editor as any).can().undo() : false;
		},
		canRedo(): boolean {
			return this.editor ? !!(this.editor as any).can().redo() : false;
		},
	},
	methods: {
		onUndo() {
			(this.editor as any)?.chain?.().focus().undo().run();
		},
		onRedo() {
			(this.editor as any)?.chain?.().focus().redo().run();
		},
	},
});
</script>
